import React from "react";
import { Link } from "react-router";
import { CircularProgress, RaisedButton } from "material-ui";
import assign from "lodash/assign";
import chunk from "lodash/chunk";
import { colors } from "material-ui/styles";
import Helmet from "react-helmet";

import { capitalize, formatPrice, isApp } from "../util";
import InjectedTenantHTML from "./partials/injected-tenant-html.jsx";

class Donate extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isNative: false };

    this.getStyles = this.getStyles.bind(this);
    this._renderDonateButtons = this._renderDonateButtons.bind(this);
  }

  static get contextTypes() {
    return {
      appSettings: React.PropTypes.object,
      muiTheme: React.PropTypes.object,
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      isLarge: React.PropTypes.bool
    };
  }

  componentDidMount() {
    // Native app - force redirect
    if (navigator.userAgent.indexOf("gonative") > -1) {
      window.open(window.location.href + "?external", "_blank");
      this.setState({ isNative: true });
    }
  }

  getStyles() {
    let primaryColor = this.context.muiTheme.rawTheme.palette.primary1Color,
      { isLarge } = this.context;

    return {
      loading: {
        padding: "30px 10px",
        textAlign: "center"
      },
      appMessage: {
        padding: 10,
        paddingTop: 30,
        textAlign: "center",
        fontSize: "12pt"
      },
      container: {
        padding: 10
      },
      title: {
        textAlign: "center",
        fontSize: 30
      },
      donateButtonsContainer: {
        marginTop: "2em",
        textAlign: "center"
      },
      donateButton: {
        marginRight: 10,
        marginBottom: 10,
        minWidth: 90,
        height: 50
      },
      donateButtonLabel: {
        fontSize: "1.25em"
      }
    };
  }

  _renderDonateButtons() {
    let styles = this.getStyles();

    return (
      <div style={styles.donateButtonsContainer}>
        {this.context.tenant.donate_page_levels.map(level => {
          return (
            <RaisedButton
              className="eventive__donate-button__button"
              style={styles.donateButton}
              labelStyle={styles.donateButtonLabel}
              primary={true}
              label={formatPrice(level.amount, /* short */ true)}
              onClick={() =>
                this.context.router.push({
                  pathname: "/donate/go",
                  query: { amount: level.amount },
                  state: { fromMainListing: true }
                })
              }
            />
          );
        })}
        {this.context.tenant.donate_show_other ? (
          <RaisedButton
            style={Object.assign({}, styles.donateButton, { marginRight: 0 })}
            labelStyle={styles.donateButtonLabel}
            label="Other"
            className="eventive__donate-button__button eventive__donate-button__button--other"
            onClick={() =>
              this.context.router.push({
                pathname: "/donate/go",
                state: { fromMainListing: true }
              })
            }
          />
        ) : null}
      </div>
    );
  }

  render() {
    let styles = this.getStyles();

    if (!this.context.appSettings.donations_enabled) {
      return (
        <div style={styles.loading}>
          <CircularProgress
            mode="indeterminate"
            size={119}
            thickness={7}
            style={{ margin: 10.5 }}
          />
        </div>
      );
    }

    /*if (isApp()) {
      return (
        <div style={styles.appMessage} className="Eventive--DonatePage">
          This functionality is not available in the App.
        </div>
      );
    }*/

    if (this.state.isNative) {
      return <div style={styles.loading}>Thank you for your donation.</div>;
    }

    return (
      <div className="Eventive--DonatePage">
        <Helmet title={this.context.tenant.donate_page_title} />
        {this.props.children
          ? React.cloneElement(this.props.children, {
              appSettings: this.props.appSettings
            })
          : undefined}

        <div style={styles.container}>
          <h2 style={styles.title}>{this.context.tenant.donate_page_title}</h2>
          <InjectedTenantHTML
            content={this.context.tenant.donate_page_content}
          />
          {this._renderDonateButtons()}
        </div>
      </div>
    );
  }
}

export default Donate;



// WEBPACK FOOTER //
// ./src/app/components/donate.jsx